import { useEffect, useState } from 'react'
import { navigateTo } from '@/lib/navigate'
import FlipButton from '@/components/ui/FlipButton'

/*
  Confirmation page after a successful sign-out. The session is already
  destroyed by the time we land here (the platformOS sign_out form runs
  callback_actions and redirects to /sign-out). Just show a friendly
  acknowledgement and a link back to the marketplace or sign-in page.

  Styling lives in src/styles/pages/signout-success.css; the title row's
  fade-in animation is driven by `data-visible` on the shared
  .mig-page-title-row helper.
*/

export default function SignOutSuccess() {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100)
    return () => clearTimeout(t)
  }, [])

  return (
    <section className="mig-signout-section">
      <div className="mig-page-title-row mig-signout-title-row" data-visible={visible}>
        <h1 className="mig-signout-title">Signed out</h1>
      </div>

      <div className="mig-signout-body">
        <p className="mig-signout-message">
          You have been signed out securely. Thank you for visiting Migration Galleries.
        </p>
        <div className="mig-signout-actions">
          <FlipButton
            onClick={navigateTo('/marketplace')}
            className="mig-signout-primary"
          >
            Continue browsing
          </FlipButton>
          <a href="/sign-in" className="mig-signout-secondary">
            Sign in again
          </a>
        </div>
      </div>
    </section>
  )
}
